import { Input, Textarea, Box } from '@chakra-ui/react'
import { useState } from 'react'
import TextEditorOptions from '../TextEditorOptions'
interface ParagraphCardProps {
  paragraph?: string
  short?: string
  onChange?: (val: string) => void
  isShort?: boolean
  isEditing?: boolean
  quizMode?: boolean
  isSurvey?: boolean
  onAnswer?: (questionId: string, answer: string) => void
  questionId?: string
  response?: string
  isIndividualResponse?: boolean
  enableEditor?: boolean
}

const ParagraphCard: React.FC<ParagraphCardProps> = ({
  paragraph,
  short,
  onChange,
  isShort = false,
  isEditing,
  quizMode,
  questionId,
  isSurvey = false,
  onAnswer,
  response,
  isIndividualResponse = false,
  enableEditor,
}) => {
  const [currentText, setCurrentText] = useState<string>(short || paragraph || '')

  const handleUpdate = () => {
    if (onAnswer && questionId) {
      onAnswer(questionId, currentText)
    }
    onChange?.(currentText || '')
  }

  if (isSurvey) {
    return (
      <Input
        size="s"
        value={currentText || response || ''}
        variant={'paragraphInput'}
        color="solid.900"
        placeholder={'Answer'}
        w="99%"
        onChange={(e) => setCurrentText(e.target.value)}
        onBlur={handleUpdate}
        isReadOnly={!quizMode || isIndividualResponse}
        maxLength={222}
      />
    )
  }

  if (isEditing && isShort) {
    return (
      <Input
        size="s"
        value={currentText ?? ''}
        variant={'paragraphInput'}
        color="solid.900"
        placeholder="Answer"
        w="99%"
        onChange={(e) => setCurrentText(e.target.value)}
        onBlur={handleUpdate}
        isReadOnly={!isEditing || quizMode}
        maxLength={222}
      />
    )
  } else if (isEditing && !quizMode) {
    if (enableEditor && !isShort) {
      return (
        <Box style={{ cursor: 'text' }}>
          <TextEditorOptions
            value={currentText}
            placeholder="Paragraph"
            minHeight={200}
            onChange={(html) => {
              setCurrentText(html)
              onChange?.(html)
            }}
            onBlur={handleUpdate}
          />
        </Box>
      )
    }

    return (
      <Textarea
        size="s"
        value={currentText ?? ''}
        variant={'textAreaQuestion'}
        color="solid.900"
        placeholder="Paragraph"
        w="100%"
        resize="vertical"
        minH="200px"
        h="100%"
        onChange={(e) => setCurrentText(e.target.value)}
        onBlur={handleUpdate}
        isReadOnly={!isEditing}
        tabIndex={!isEditing ? -1 : 0}
        display="flex"
        bg="transparent"
      />
    )
  } else {
    // Always render HTML in view and quiz mode (not editing)
    return <Box whiteSpace="pre-wrap" dangerouslySetInnerHTML={{ __html: currentText }} />
  }
}

export default ParagraphCard
